<vb-modal
  [visible]="isOpen()"
  title="Request Access"
  size="md"
  [closable]="!isSubmitting"
  [closeOnBackdropClick]="!isSubmitting"
  [closeOnEscape]="!isSubmitting"
  [showFooter]="false"
  (onCancel)="close()"
  (visibleChange)="onVisibleChange($event)">

  <div class="mb-4 p-3 bg-base-200 rounded-lg border border-base-300">
    <p class="text-sm text-base-content/70">
      Requesting access to: <span class="font-semibold text-primary">{{ appName() }}</span>
    </p>
  </div>

  @if (isSubmitSuccessful) {
    <vb-alert
      type="success"
      variant="soft"
      [showIcon]="true"
      [title]="alreadySubmittedMessage || 'Request submitted successfully!'"
      [message]="alreadySubmittedMessage ? '' : successMessage()"
      class="block mb-4"
    />
  }

  @if (errorMessage) {
    <vb-alert
      type="error"
      variant="soft"
      [showIcon]="true"
      [message]="errorMessage"
      class="block mb-4"
    />
  }

  @if (!isSubmitSuccessful) {
    <form [formGroup]="form" (ngSubmit)="submit()">
      <div class="mb-4">
        <vb-input
          id="userName"
          name="userName"
          type="text"
          label="Name"
          [required]="true"
          [state]="form.controls.formUserName.touched && form.controls.formUserName.invalid ? 'error' : 'default'"
          formControlName="formUserName"
        />
      </div>

      <div class="mb-4">
        <vb-input
          id="userEmail"
          name="userEmail"
          type="email"
          label="Email"
          [value]="userEmail()"
          [disabled]="true"
        />
      </div>

      @if (isVerticalWorks()) {
        <!-- Last field in the Vertical Works branch, so it carries the
             pre-footer spacing the reason textarea gives the others. -->
        <div class="mb-6">
          <vb-input
            id="companyName"
            name="companyName"
            type="text"
            label="Company Name"
            placeholder="Enter your company name"
            [required]="true"
            [state]="form.controls.companyName.touched && form.controls.companyName.invalid ? 'error' : 'default'"
            formControlName="companyName"
          />
        </div>
      }

      @if (appType() === 'partnerPortal') {
        <div class="mb-4">
          <vb-input
            id="portfolioName"
            name="portfolioName"
            type="text"
            label="Portfolio Name"
            placeholder="Enter portfolio name"
            [required]="true"
            [state]="form.controls.portfolioName.touched && form.controls.portfolioName.invalid ? 'error' : 'default'"
            formControlName="portfolioName"
          />
        </div>
      }

      <!-- Vertical Works' request endpoint has no field for a reason, so it
           isn't collected there. -->
      @if (!isVerticalWorks()) {
      <div class="mb-6">
        <vb-textarea
          id="reason"
          label="Reason for Access"
          placeholder="Please explain why you need access to this application..."
          [rows]="3"
          [required]="true"
          [state]="form.controls.reason.touched && form.controls.reason.invalid ? 'error' : 'default'"
          formControlName="reason"
        />
      </div>
      }

      <div class="flex gap-3 justify-end">
        <vb-button
          type="button"
          variant="ghost"
          size="md"
          [disabled]="isSubmitting"
          (click)="close()">
          Cancel
        </vb-button>
        <vb-button
          type="submit"
          variant="primary"
          size="md"
          [loading]="isSubmitting"
          [disabled]="isSubmitting || form.invalid">
          @if (isSubmitting) {
            Submitting...
          } @else {
            Submit Request
          }
        </vb-button>
      </div>
    </form>
  } @else {
    <div class="flex justify-end">
      <vb-button variant="primary" size="md" (click)="close()">
        Close
      </vb-button>
    </div>
  }
</vb-modal>
